import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  useTheme,
  TextField,
  Stack,
} from "@mui/material";
import { useFormRCAutoDetails } from "../rcautoContext";
import { NumericFormat } from "react-number-format";
import { DatePicker } from "@mui/x-date-pickers";
import { parseDate } from "../../rcAutoDetails2/helpers";

const formatDate = (date) => {
  if (!date) return "";
  if (typeof date === "string" && date.includes("/")) return date;
  // Accepts Date object
  const d = new Date(date);
  if (isNaN(d)) return "";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

const ModificaDialog = ({ open, onClose, idUID, type }) => {
  const { formState, dispatch } = useFormRCAutoDetails();
  const theme = useTheme();

  const data = formState.preventivi?.[type]?.find((p) => p.idUID === idUID);

  const [localData, setLocalData] = useState({
    tariffa: 0,
    dataDecorrenza: null,
    scadenzaLibroMatricola: null,
  });

  useEffect(() => {
    if (data && open) {
      setLocalData({
        tariffa: data.dettagli?.tariffa || 0,
        dataDecorrenza: data.ratino?.dataDecorrenza
          ? parseDate(data.ratino.dataDecorrenza)
          : null,
        scadenzaLibroMatricola: data.ratino?.scadenzaLibroMatricola
          ? parseDate(data.ratino.scadenzaLibroMatricola)
          : null,
      });
    }
  }, [data, open]);

  const handleSave = () => {
    if (!data) return;

    const updatedPreventivo = {
      ...data,
      dettagli: {
        ...data.dettagli,
        tariffa: Number(localData.tariffa),
      },
    };

    if (data.ratino && Object.keys(data.ratino).length > 0) {
      updatedPreventivo.ratino = {
        ...data.ratino,
        dataDecorrenza: localData.dataDecorrenza
          ? formatDate(localData.dataDecorrenza)
          : data.ratino.dataDecorrenza,
        scadenzaLibroMatricola: localData.scadenzaLibroMatricola
          ? formatDate(localData.scadenzaLibroMatricola)
          : data.ratino.scadenzaLibroMatricola,
      };
    }

    dispatch({
      type: "update_preventivo",
      payload: { typePrev: type, idUID, preventivo: updatedPreventivo },
    });
    onClose();
  };

  const hasRatino = data?.ratino && Object.entries(data.ratino).length > 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "400px",
            backgroundColor:
              theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
          },
        },
      }}
    >
      <DialogTitle>Modifica preventivo</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          <NumericFormat
            customInput={TextField}
            label="Tariffa"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fullWidth
            value={localData.tariffa}
            onValueChange={(values) => {
              setLocalData((prev) => ({ ...prev, tariffa: values.value }));
            }}
          />
          {hasRatino && (
            <>
              <DatePicker
                label="Data Decorrenza"
                value={localData.dataDecorrenza}
                onChange={(date) =>
                  setLocalData((prev) => ({ ...prev, dataDecorrenza: date }))
                }
                inputFormat="dd/MM/yyyy"
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
              <DatePicker
                label="Scadenza Libro Matricola"
                value={localData.scadenzaLibroMatricola}
                onChange={(date) =>
                  setLocalData((prev) => ({
                    ...prev,
                    scadenzaLibroMatricola: date,
                  }))
                }
                inputFormat="dd/MM/yyyy"
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Chiudi</Button>
        <Button variant="contained" onClick={handleSave}>
          Salva
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModificaDialog;
